// src/data/servicesData.js
import { FaBook, FaGraduationCap, FaHome, FaLeaf, FaPassport, FaPlaneDeparture } from 'react-icons/fa';

const servicesData = [
  {
    title: 'Study Consultation',
    text: 'We guide you through course selection, university applications, and documentation.',
    color: '#d1e7dd',
    icon: <FaGraduationCap size={30} color="#055160" />,
  },
  {
    title: 'Visa Assistance',
    text: 'Expert help with visa paperwork and interview preparation to ensure your approval.',
    color: '#cff4fc',
    icon: <FaPassport size={30} color="#055160" />,
  },
  {
    title: 'Pre-departure Support',
    text: 'Orientation sessions, travel arrangements, and settling-in services in Japan.',
    color: '#fce7f3',
    icon: <FaPlaneDeparture size={30} color="#055160" />,
  },
  {
    title: 'Japanese Lifestyle Training',
    text: 'Learn customs, manners, and everyday etiquette essential for living in Japan.',
    color: '#fff3cd',
    icon: <FaLeaf size={30} color="#055160" />,
  },
  {
    title: 'Life Skills Practice Room',
    text: 'Simulate real-life scenarios like using transit, shopping, and waste disposal in Japan.',
    color: '#ede7f6',
    icon: <FaHome size={30} color="#055160" />,
  },
  {
    title: 'Library & Counseling',
    text: 'Access personal guidance, mental wellness support, and academic resources.',
    color: '#e3f2fd',
    icon: <FaBook size={30} color="#055160" />,
  },
];

export default servicesData;